// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import ErrorBoundary from '../../components/error/errorBoundary/ErrorBoundary';
import CanvasErrorRenderer from './CanvasErrorRenderer';

const getErrorMessage = (error) => `Error rendering canvas: ${error.toString()}`;

const getRollbarErrorDetails = (error, info, props) => ({
    boardId: props.currentBoardId,
    stack: info.componentStack,
    // Only Safari and Firefox provide these details
    filename: (error && error.sourceURL) || error.fileName || 'unknown',
    line: (error && error.line) || error.lineNumber || 'unknown',
    column: (error && error.column) || error.columnNumber || 'unknown',
});

const CanvasErrorBoundary = (props) => (
    <ErrorBoundary
        {...props}
        ErrorRenderer={CanvasErrorRenderer}
        getErrorMessage={getErrorMessage}
        getRollbarErrorDetails={getRollbarErrorDetails}
    />
);

CanvasErrorBoundary.propTypes = {
    currentBoardId: PropTypes.string,
};

export default CanvasErrorBoundary;
